import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

export const QuestionLabel = ({
  label,
  info
}: {
  label: string
  info?: string
}) => {
  const [openQuestionInfo, setOpenQuestionInfo] = React.useState(false)

  return (
    <label
      className={`block bold mb-2 ${info ? 'cursor-pointer' : ''}`}
      onClick={() => {
        if (info) {
          setOpenQuestionInfo(prev => !prev)
        }
      }}
    >
      {label}
      &nbsp;
      {info && (
        <FontAwesomeIcon
          icon={'info-circle'}
          className='text-icon-muted'
        />
      )}

      {openQuestionInfo && info && (
        <div className='mt-2 rounded-lg bg-surface-info p-4 text-sm text-text-secondary'>
          <FontAwesomeIcon
            icon='times'
            className='float-right cursor-pointer text-icon-secondary'
            onClick={() => setOpenQuestionInfo(false)}
          />

          <div
            className='html-content p-4'
            dangerouslySetInnerHTML={{ __html: info }}
          />
        </div>
      )}
    </label>
  )
}
